import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  AutomotiveAftermarketReportInitialState,
  AutomotiveAftermarketReportLoad,
} from './automotive-aftermarket-report.actions';
import { AutomotiveAftermarketReportState } from './automotive-aftermarket-report.state';
import { AutomotiveAftermarketProfileReport } from '../models/automotive-aftermarket-report.model';
import { ProfileReportItem } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class AutomotiveAftermarketReportFacade implements LoadDataFacade, SetInitialStateFacade {
  report$: Observable<AutomotiveAftermarketProfileReport> = this.store.select(
    AutomotiveAftermarketReportState.getReport,
  );
  loaded$: Observable<boolean> = this.store.select(AutomotiveAftermarketReportState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new AutomotiveAftermarketReportLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new AutomotiveAftermarketReportInitialState());
  }

  setReportRequiredFields(report: AutomotiveAftermarketProfileReport): AutomotiveAftermarketProfileReport {
    const result = {} as AutomotiveAftermarketProfileReport;
    Object.keys(report).forEach((reportKey: string) => {
      result[reportKey] = Array.isArray(report[reportKey])
        ? report[reportKey].filter((item: ProfileReportItem) => item.required)
        : report[reportKey];
    });
    return result;
  }
}
